import React from 'react';
import Joi from 'joi-browser';
import * as _ from 'lodash';
import { validationByJoi } from '../utilities/commonValidation';

import { FieldItemService } from '../services/FieldItems';
import { FieldItemInputService } from '../services/FieldItemInputs';
import { FieldService } from '../services/Fields';
import SessionStorageService from '../services/utilities/SessionStorageService';

import { FieldItemContents } from '../components/tables/FieldItems';
import { Delete } from './modals/Commons';
import dialogLoader from '../utilities/dialogLoader';
import * as dialog from '../components/FieldTreeDialog';
import urlParamManager from '../utilities/urlParamManager';
import { TouchDeviceInvisible } from '../components/TouchDeviceInvisible';

import Helmet from 'react-helmet';
import { HEADER_CONSTANTS } from '../utilities/constants';
import { csvDownloader } from '../utilities/commonUtil';
import InfinityScrollLoad from '../components/InfinityScrollLoad';
import { deleteControlCode } from '../utilities/stringUtil';

/**
 * @description 作業場所1, 2, 3, 4画面
 */
export class FieldAItems extends React.Component {
  constructor(props) {
    super(props);

    this.state = this.getInitializeState();
    this.isRequestingFlag = false;
    this.defaultValues = {
      id: null,
      name: '',
      display_flag: 1,
    };
    this.events = {
      form: {
        setFormValues: this.setFormValues.bind(this),
        clearFormValues: this.clearFormValues.bind(this),
        set: this.setFlatData.bind(this),
        validate: this.validate.bind(this),
        submit: this.eventSubmit.bind(this),
      },
      modal: {
        deleteModal: this.deleteModal.bind(this),
        delete: this.deleteGate.bind(this),
      },
      //ドラッグアンドドロップ用メソッド
      dnd: {
        onBeginDrag: this.onBeginDrag.bind(this),
        onDropped: this.onDropped.bind(this),
        onHover: this.onHover.bind(this),
        draggable: this.draggable.bind(this),
        orderSubmit: this.eventOrderSubmit.bind(this),
      },
    };
    this.csvDownloadPreparation = this.csvDownloadPreparation.bind(this);

    this.schema = Joi.object().keys({
      id: Joi.allow(),
      name: Joi.string()
        .max(127)
        .required(),
      display_flag: Joi.number()
        .max(1)
        .required(),
    });

    //componentWillRecievesPropsをイベントで実行する
    urlParamManager.setPageNumberDelegate('FieldAItems', (page, vw, id) => {
      this.recievedProps(id);
      this.setState({ canDrag: false });
    });
  }

  getInitializeState = itemListId => {
    let newItemListId;
    if (itemListId) {
      newItemListId = itemListId;
    } else {
      // this.props.param[1]に値が入っているはずだがコードは残しておく
      // this.props.paramに直接入っているパターンもある
      newItemListId = _.has(this.props.match, 'params')
        ? this.props.match.params.id
        : this.props.param.id || this.props.param[1] || this.props.param;
    }
    // 文字列または数値がくるので数値に統一
    const parsedItemListId = _.isNil(newItemListId)
      ? null
      : _.parseInt(newItemListId);

    return {
      loaded: false,
      fieldId: sessionStorage.getItem('field_id'),
      itemListId: parsedItemListId,
      itemListTitle: '',
      fieldItems: [],
      canDrop: false, //ドラッグアンドドロップの状態
      searched: false, //検索の状態
      dragSort: [], //ドラッグアンドドロップの並び順の仮置き場
      searchParam: {
        name: '',
      },
      orderParam: {
        order: 'order_number_asc',
      },
      isOpened: false,
      isSettingId: null,
      formValues: {},
      errors: {},
      validateName: '',
      canDrag: false,
      isLoading: true, // ロード中フラグ
      isRegisterWaiting: false, // 連打防止用
    };
  };

  setFieldNameById(fieldId) {
    if (!fieldId) {
      return;
    }
    FieldService.info(fieldId).then(response => {
      if (response.result) {
        this.setState({ fieldName: response.data.entities.field.name });
      }
    });
  }

  componentDidMount() {
    this.setFieldItems();
  }

  componentWillUnmount() {
    urlParamManager.removePageNumberDelegate('FieldAItems');
  }

  recievedProps(itemListId) {
    this.setState(this.getInitializeState(itemListId), () => {
      if (itemListId !== this.state.itemListId) {
        this.setFieldItems();
      }
    });
  }

  /**
   * ホバー
   */
  // eslint-disable-next-line no-unused-vars
  onHover(props, monitor, component) {}

  /**
   * ドラッグ開始
   */
  // eslint-disable-next-line no-unused-vars
  onBeginDrag(props, monitor, component) {
    let dragSort = _.cloneDeep(this.state.dragSort);
    dragSort[0] = props.index;
    this.setState({ dragSort });
  }

  /**
   * ドロップダウン
   */
  // eslint-disable-next-line no-unused-vars
  onDropped(dragProps, dropProps, monitor, dropComponent) {
    let dragSort = _.cloneDeep(this.state.dragSort);
    dragSort[1] = dropProps.index;
    this.setState({ dragSort });
    this.sortList(...this.state.dragSort);
  }

  /**
   * ドラッグ開始、終了
   */
  draggable(bool) {
    this.setState({ canDrag: bool });
  }

  /**
   * @description 並び順を変更する
   */
  sortList(dragIndex, to_index) {
    const lists = _.cloneDeep(this.state.fieldItems);
    const formItem = lists[dragIndex];
    if (to_index < dragIndex) {
      lists.splice(to_index, 0, formItem);
      lists.splice(dragIndex + 1, 1);
    } else {
      lists.splice(to_index + 1, 0, formItem);
      lists.splice(dragIndex, 1);
    }
    this.setState({ fieldItems: lists });
  }

  async setFieldItems(searchParam, notify) {
    if (this.state.loaded && notify) {
      notify();
      this.setState({ isLoading: false });
      return;
    }

    // 通常ないはずだがnullでAPI呼ぶとエラーになるので実行しない
    if (_.isNil(this.state.itemListId)) {
      return;
    }

    const pageParam = {
      offset: notify ? _.size(this.state.fieldItems) : 0,
    };
    const fieldId = this.state.fieldId;
    const itemParams = _.assign(
      { order: 'order_number_asc' },
      searchParam,
      pageParam
    );
    let params = {
      field_id: SessionStorageService.getFieldId(),
      limit: 30,
      item_list_ids: [this.state.itemListId],
    };
    params = _.merge(params, itemParams);
    await FieldItemService.list(fieldId, params).then(resp => {
      if (resp.result) {
        let getfieldItems;
        switch (this.state.itemListId) {
          case 1:
            getfieldItems = resp.data.entities.field_item_a_lists;
            break;
          case 2:
            getfieldItems = resp.data.entities.field_item_b_lists;
            break;
          case 3:
            getfieldItems = resp.data.entities.field_item_c_lists;
            break;
          case 4:
            getfieldItems = resp.data.entities.field_item_d_lists;
            break;
        }
        if (_.isEmpty(getfieldItems) && notify) {
          this.setState({
            loaded: true,
          });
        } else {
          let fieldItems = notify ? _.cloneDeep(this.state.fieldItems) : [];
          _.each(getfieldItems, getfieldItem => {
            fieldItems.push(getfieldItem);
          });
          this.setState({
            fieldItems,
            total: resp.data.total,
            loaded: false,
          });
          this.getItemListTitle();
        }
      }
      this.setState({ isLoading: false });
      if (notify) {
        notify();
        return;
      }
    });
  }

  getItemListTitle() {
    const fieldId = this.state.fieldId;
    const params = {};
    FieldItemInputService.list(fieldId, params).then(resp => {
      if (resp.result) {
        this.setState({
          itemListTitle:
            resp.data.entities.field_item[
              `field_item_list${this.state.itemListId}_title`
            ],
        });
      }
    });
  }

  handleSearchFormShow = () => {
    this.setState({ isOpened: !this.state.isOpened });
  };

  setFormValues = fieldItem => {
    const formValues = {};
    _.each(Object.keys(this.defaultValues), key => {
      formValues[key] = fieldItem[key];
    });
    this.setState({
      isSettingId: fieldItem.id ? fieldItem.id : 0,
      formValues,
      errors: {},
      validateName: fieldItem.name,
    });
  };

  clearFormValues = () => {
    this.setState({
      isSettingId: null,
      formValues: this.defaultValues,
      errors: {},
    });
  };

  onChangeSearchParam = e => {
    const searchParam = this.state.searchParam;
    let searched = false;
    searchParam[e.target.name] = e.target.value;
    _.each(searchParam, value => {
      if (value !== '') {
        searched = true;
      }
    });
    this.setState({
      searchParam,
      searched,
      isLoading: true,
      fieldItems: [],
    });
    this.setFieldItems(searchParam);
  };

  onClearSearchParam = async () => {
    if (this.isRequestingFlag) {
      return;
    }
    this.isRequestingFlag = true;
    const searchParam = {
      name: '',
    };
    this.setState({
      searchParam,
      searched: false,
      isLoading: true,
      fieldItems: [],
    });
    await this.setFieldItems(searchParam);
    this.isRequestingFlag = false;
  };

  setFlatData = e => {
    let formValues = this.state.formValues;
    formValues[e.target.name] = deleteControlCode(e.target.value);
    this.setState({ formValues });
  };

  deleteModal(deleteId, callbacks) {
    dialogLoader.show(Delete, {
      state: {
        deleteId,
        callbacks,
      },
    });
  }

  deleteGate = id => {
    // BLDE_V2-50769: isLoadingがTrueならdeleteGateが発生しないため、連打防止
    if (!this.state.isLoading) {
      this.setState({ isLoading: true }, () => {
        const fieldId = this.state.fieldId;
        FieldItemService.del(fieldId, id)
          .then(resp => {
            if (resp.result) {
              this.setFieldItems(this.state.searchParam);
              this.setState({
                isSettingId: null,
                errors: {},
              });
              dialogLoader.close();
            } else {
              dialogLoader.show(dialog.NeverDeletePartnerCompany, {
                message: _.get(resp, 'data.message'),
                callback: {
                  done: () => {
                    dialogLoader.close();
                  },
                },
              });
            }
          })
          .finally(() => {
            // 削除が終わったら連打禁止を解除
            this.setState({ isLoading: false });
          });
      });
    }
  };
  validate(e) {
    const params = this.state.formValues;
    const result = validationByJoi(this.schema, params);
    const errors = this.state.errors;
    if (result.messages[e.target.name]) {
      errors[e.target.name] = result.messages[e.target.name];
    } else if (errors[e.target.name]) {
      delete errors[e.target.name];
    }
    this.setState({ errors });
  }

  eventSubmit() {
    if (this.state.isRegisterWaiting) {
      return;
    } else {
      this.setState({ isRegisterWaiting: true }, () => {
        const params = this.state.formValues;
        const result = validationByJoi(this.schema, params);
        const errors = result.messages;
        this.setState({ errors }, () => {
          if (_.size(this.state.errors) !== 0) {
            this.setState({
              isRegisterWaiting: false,
            });
            return;
          }
          let params = this.state.formValues;
          let item_list_id = {
            item_list_id: this.state.itemListId,
          };
          const id = params.id;
          const fieldId = this.state.fieldId;
          params = _.merge(params, item_list_id);
          const newState = {}
          if (id) {
            // 更新時
            FieldItemService.update(fieldId, id, params).then(resp => {
              if (!resp.result) {
                newState.errors = _.cloneDeep(this.state.errors);
                newState.errors.name = resp.data.message;
                return;
              }
              this.setFieldItems(this.state.searchParam);
              newState.isSettingId = null;
              newState.errors = {};
            }).finally(() => {
              newState.isRegisterWaiting = false;
              this.setState(newState);
            });
          } else {
            // 登録時
            FieldItemService.create(fieldId, params).then(resp => {
              if (!resp.result) {
                newState.errors = _.cloneDeep(this.state.errors);
                newState.errors.name = resp.data.message;
                return;
              }
              this.setFieldItems(this.state.searchParam);
              newState.isSettingId = null;
              newState.errors = {};
            }).finally(() => {
              newState.isRegisterWaiting = false;
              this.setState(newState);
            });
          }
        });
      });
    }
  }

  eventOrderSubmit = () => {
    const fieldId = this.state.fieldId;
    const items = this.state.fieldItems;
    const params = { ids: _.map(items, 'id') };
    FieldItemService.updateOrder(fieldId, params).then(resp => {
      if (resp.result) {
        this.setFieldItems(this.state.searchParam);
      }
    });
  };

  /**
   * @description CSV出力準備
   */
  csvDownloadPreparation() {
    const params = { ...this.state.searchParam };
    params.item_list_ids = [this.state.itemListId];
    const apiPath = `api/private/fields/${this.state.fieldId}/field_item_lists/list.csv`;

    csvDownloader(apiPath, params);
  }

  headerMenu = () => {
    if (this.state.canDrag) {
      return (
        <div className='setting-header__item'>
          <button
            className='btn--effective'
            onClick={() => {
              this.events.dnd.orderSubmit();
              this.events.dnd.draggable(false);
            }}
          >
            保存
          </button>
        </div>
      );
    }
    return (
      <div className='setting-header__item'>
        <button
          className='btn'
          onClick={() => this.events.form.setFormValues(this.defaultValues)}
          style={{
            display: this.state.isSettingId !== null ? 'none' : 'inline-block',
          }}
        >
          新規作成
        </button>
        <ul className='btn-menu'>
          <TouchDeviceInvisible>
            <li className='btn-menu__item'>
              <button
                className='btn--sub'
                onClick={() => this.events.dnd.draggable(true)}
                style={{
                  display:
                    this.state.searched || this.state.isSettingId !== null
                      ? 'none'
                      : 'inline-block',
                }}
              >
                並び順を変更する
              </button>
            </li>
          </TouchDeviceInvisible>
          <li className='btn-menu__item'>
            <button
              className='btn--sub'
              onClick={this.csvDownloadPreparation}
              style={{
                display: !_.isNull(this.state.isSettingId)
                  ? 'none'
                  : 'inline-block',
              }}
            >
              表示データをCSV出力
            </button>
          </li>
        </ul>
      </div>
    );
  };

  render() {
    return (
      <div id='infinityscroll-target-id' className='setting-main__body'>
        <Helmet>
          {/* https://github.com/nfl/react-helmet/issues/274
              なぜか{HEADER_CONSTANTS.conference} - {this.state.itemListTitle}だとエラーが起きる */}
          <title>
            {`${HEADER_CONSTANTS.conference} - ${this.state.itemListTitle}`}
          </title>
        </Helmet>
        <div id='setting-header' className='setting-header'>
          {this.headerMenu()}
          <div className='setting-header__item'>
            <div
              className='search-form'
              style={{
                display: this.state.canDrag ? 'none' : 'inline-block',
              }}
            >
              <div className='search-form__header'>
                <div className='search-form__title'>
                  検索条件（検索結果
                  <span className='bold'>{this.state.total}</span>
                  件)
                </div>
                <button
                  id='setting-search-accordion-toggle'
                  className={
                    this.state.isOpened
                      ? 'accordion__btn show'
                      : 'accordion__btn'
                  }
                  onClick={e => this.handleSearchFormShow(e)}
                />
                <button
                  className='btn-text--sm'
                  onClick={this.onClearSearchParam}
                >
                  検索条件クリア
                </button>
              </div>
              <div
                id='setting-search-accordion'
                className={this.state.isOpened ? 'accordion show' : 'accordion'}
              >
                <div className='search-form__body'>
                  <div className='form form--search-form'>
                    <div className='form-element'>
                      <div className='form-element__label'>
                        <span className='label'>名称</span>
                      </div>
                      <div className='form-element__element --col-xs-12 --col-md-12 --col-lg-4 --col-xl-4'>
                        <input
                          type='text'
                          placeholder='名称'
                          name='name'
                          value={this.state.searchParam.name}
                          onChange={this.onChangeSearchParam}
                          className=''
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <FieldItemContents
          fieldItems={this.state.fieldItems}
          values={this.state.formValues}
          errors={this.state.errors}
          isSettingId={this.state.isSettingId}
          callbacks={this.events}
          canDrag={this.state.canDrag}
          infinityScrollLoad={
            <InfinityScrollLoad
              targetId='infinityscroll-target-id'
              total={_.size(this.state.fieldItems)}
              isLoading={this.state.isLoading}
              callback={notifyEnd => {
                this.setFieldItems(this.state.searchParam, notifyEnd);
              }}
            />
          }
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/FieldAItems.jsx